import React from 'react';
import {useTranslation} from 'react-i18next';

import ButtonWhatsApp from '../../shared/components/buttons/ButtonWhatsApp';
import Screen from './screen';

const About: React.FC = () => {
  const {t} = useTranslation();

  return (
    <Screen className="result loading  pb-60">
      <h2 className="primary-title">{t('sobre.sobre-sei')}</h2>
      <p className="default-subtitle mt-0 text-center">
        {t('sobre.sobre-sei-subtitle')}
      </p>

      <p>{t('sobre.sobre-sei-text')} </p>

      <ButtonWhatsApp />
    </Screen>
  );
};

export default About;



// WEBPACK FOOTER //
// ./src/features/election/About.tsx